import React, {Component} from 'react'

import styled from '@emotion/styled'
import StyleVariales from '../styles/styles'
import {Eye, EyeOff} from 'react-feather'

// STYLE ##########################################################

const sv = StyleVariales;

const FieldContainer = styled(`div`)`
  width: 100%;
  margin-top: 24px;
`;

const Label = styled(`div`)`
  ${sv.label};
  text-transform: none;
  font-size: 12px;
  font-weight: bold;
  color: ${sv.colors.dark};
  margin-bottom: 8px;
  width: 100%;
`;

const InputContainer = styled(`div`)`
  width: 100%;
  position: relative;
`;

const Input = styled(`input`)`
  padding: 16px;
  font-size: 16px;
  border: 1px solid ${sv.colors.subtleGrey};
  border-radius: 4px;
  width: 100%;
  ::-webkit-input-placeholder {
    color: ${sv.colors.subtleGrey};
  }
  ${sv.box};
`;

const PasswordIcon = styled(`div`)`
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 0 16px;
  height: 100%;
  cursor: pointer;
  ${sv.flexCenter};
`;

// COMPONENT ##########################################################

class FormField extends Component {

  state = {
    hidePassword: true
  };

  toggleHidePassword = () => {
    this.setState({hidePassword: !this.state.hidePassword})
  };

  enterPressed(event) {
    var code = event.keyCode || event.which;
    if (code === 13) {
      if (this.props.onEnterPressed) {
        this.props.onEnterPressed(event);
      }
    }
  }

  render() {

    let passwordIcon;
    if (this.state.hidePassword) {
      passwordIcon = <Eye color={sv.colors.subtleGrey} size={14} />
    } else {
      passwordIcon = <EyeOff color={sv.colors.subtleGrey} size={14}  />
    }

    let inputType = 'text';
    if (this.props.password && this.state.hidePassword) inputType = 'password';

    return (
        <FieldContainer>
          <Label>{this.props.label}</Label>
          <InputContainer>
            <Input
                placeholder={this.props.placeholder}
                type={inputType}
                onChange={this.props.update}
                name={this.props.name}
                onKeyPress={this.enterPressed.bind(this)}
                disabled={this.props.disabled}
            />
            {this.props.password &&
            <PasswordIcon
                onClick={() => this.toggleHidePassword()}>
              {passwordIcon}
            </PasswordIcon>
            }
          </InputContainer>
        </FieldContainer>
    )
  }

}

export default FormField